export default __webpack_public_path__ + "static/thumb_lg_03-7f044128e69c6c509e60cae1b298e2a7.png";